<template>
	<div class="objects">
		
		<page-head-static-component :bgImg="require('@/assets/img/case_bg.png')" textColor="#FFFFFF"
		                            :headdark="true"></page-head-static-component>
		
		<case-filter-component></case-filter-component>
		
		<block-container-component>
			<template slot="content">
				<case-page-component></case-page-component>
			</template>
		</block-container-component>
		
		<cta-component>
			<template slot="button">
				<button-component class="normal-btn">Заказать звонок</button-component>
			</template>
		</cta-component>
	</div>
</template>

<script>
	//const axios = require('axios');
	export default {
		data() {
			return {}
		}
	}
</script>

<style lang="scss" scoped>
	
	.objects {
		background-color: $bg2Color;
	}

</style>